import { keyMirror } from '../modules/helpers';

/**
 * @namespace Constants
 * @desc App constants
 */

/**
 * @constant {Object} ActionTypes
 * @memberof Constants
 */
export const ActionTypes = keyMirror({
  //
  STARTUP: undefined,
  EXCEPTION: undefined,
  SHOW_ALERT: undefined,
  HIDE_ALERT: undefined,
});

export const features = [
  {
    title: 'Smart Advisor',
    description: [
      'Get personalized guidance tailored to your unique financial profile.',
      'Timely, relevant suggestions — right when you need them.',
      'One intelligent source, replacing the guesswork entirely.',
    ],
  },
  {
    title: 'Your Score',
    description: [
      'Know exactly where you stand with a single, meaningful number.',
      'Track your progress over time and see how you improve.',
      'A clear signal of how well your finances are working for you.',
    ],
  },
  {
    title: 'Trends',
    description: [
      'See your journey unfold month by month in one clean view.',
      'Spot patterns before they become problems.',
      'Understand the story behind your financial decisions.',
    ],
  },
  {
    title: 'Limits & Alerts',
    description: [
      'Set boundaries that keep your goals on track effortlessly.',
      'Get notified before you overstep — not after.',
      'Everything in one place, so nothing slips through.',
    ],
  },
];
